import { StyledComponent, DefaultTheme } from 'styled-components';

import {
    pos2, pos4, pos6, pos8, 
    TraceSize, TracePosition,
    size1, size2
} from '../../core/Trace';

import { Animate } from '../Animation';

type Dir = 'top' | 'bottom' | 'left' | 'right';
export type TooltipAgregator = Record<Dir, StyledComponent<'div', DefaultTheme>>;
export type AnimationsAgregator = Record<Dir, Animate>;

export const getAnimation = (animations: AnimationsAgregator) => 
    (dir: Dir): Animate => {
        switch(dir){
            case 'top': {
                return animations.top;
            }
            case 'bottom': {
                return animations.bottom;
            }
            case 'left': {
                return animations.left;
            }
            case 'right': {
                return animations.right;
            }
        }
    }

export const getTooltip = (tooltips: TooltipAgregator) => 
    (dir: Dir) => {
        switch(dir){
            case 'top':
                return tooltips.top;
            case 'bottom':
                return tooltips.bottom;
            case 'left':
                return tooltips.left;
            case 'right':
                return tooltips.right;
        }
    }

export const getPosition = (dir: Dir): [TracePosition, boolean] => {
    switch(dir){
        case 'top':
            return [pos2, false];
        case 'bottom':
            return [pos8, false];
        case 'left':
            return [pos4, true];
        case 'right':
            return [pos6, false];
    }
}

export const getSize = (dir: Dir): TraceSize => {
    switch(dir){
        case 'top': 
            return size1;
        case 'bottom':
            return size1;
        case 'left':
            return size2;
        case 'right':
            return size1;
    }
}

export const hasPlace = (parent: HTMLElement) => 
    (tooltip: HTMLElement) => 
        (dir: Dir): Dir => {
            const rectParent = parent.getBoundingClientRect();
            const rectEl = tooltip.getBoundingClientRect();

            switch(dir){
                case 'top':
                    return rectParent.top < rectEl.top ? 'top' : 'bottom';
                case 'bottom':
                    return rectParent.bottom > rectEl.bottom ? 'bottom' : 'top';
                case 'left':
                    return rectParent.left < rectEl.left ? 'left' : 'right';
                case 'right':
                    return rectParent.right > rectEl.right ? 'right' : 'left';
            }
        }
